module.exports = __webpack_public_path__ + "img/Caribbean Meal-Jerk Chicken.86e8a804.jpg";